import React from 'react'
import { ZoneType } from '@/types'
import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/header'
import { CredenzaBody, CredenzaContent } from '@/components/ui/credenza'
import EditZonesForm from '@/components/forms/edit-zones-form'

export const Route = createFileRoute('/_home/zone-settings/zones/edit')({
  component: EditZonesPage,
})

export default function EditZonesPage({
  zoneTypeData,
  setShowEditZoneTypeModal,
}: {
  zoneTypeData: ZoneType
  setShowEditZoneTypeModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <main>
      <CredenzaContent className="flex w-full max-w-[850px] justify-center">
        <CredenzaBody className="mx-auto w-full max-w-6xl px-4">
          <Header
            subroutes={[
              {
                route: '/zone-settings/zones',
                label: 'Zones',
              },
            ]}
          >
            Edit Zone
          </Header>
          <EditZonesForm
            zoneType={zoneTypeData}
            setShowEditZoneTypeModal={setShowEditZoneTypeModal}
          />
        </CredenzaBody>
      </CredenzaContent>
    </main>
  )
}
